export async function runTraceroute(ip, workerUrl) {
  if (!workerUrl) {
    return { error: 'Traceroute worker URL not configured. Set it in Settings.' };
  }

  try {
    const res = await fetch(`${workerUrl}/traceroute`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ip }),
    });

    if (!res.ok) {
      const text = await res.text();
      return { error: `Worker error (${res.status}): ${text}` };
    }

    return res.json();
  } catch (e) {
    return { error: `Network error: ${e.message}` };
  }
}
